import cx from 'classnames';
import Link from "next/link";
import { useRouter } from "next/router";
import { FC, ReactElement, useContext, useEffect } from "react";
import { StoreContext, namespace } from '@/context';
import styles from '../index.module.scss';
import useCheckLoginState from '@/hooks/useCheckLoginState';
import userCenter from '@/constants/userCenter';
import { useGlobalContext } from '@/components/ResponsiveLayout';

/** 导航配置类型 */
export interface HomeSidebarListOption {
  key: string;
  /** 跳转路径 */
  path: string;
  /** 导航名称 */
  label: string;
  /** 导航图标 */
  icon: {
    active: ReactElement | ReactElement[],
    normal: ReactElement | ReactElement[],
  };
  /** 点击事件 */
  onClick?: () => void;
}

interface SideItems {
  options: HomeSidebarListOption[]
}

//左侧导航栏列表
const SideItems: FC<SideItems> = ({options}) => {
  const { pathname } = useRouter();
  const { isLogout } = useCheckLoginState();
  const { state } = useContext(StoreContext);
  const { track, TRACK_EVENTS } = state[namespace.app].sensors || {};
  const { activeNav, setActiveNav } = useGlobalContext();

  const onTrack = (label: string, path: string) => {
    track?.(TRACK_EVENTS?.[namespace.home].accountBarButtonClick.name, {
      button_name: label,
      position: 'Bottom',
    }, namespace.home);
    setActiveNav(path);
    window.open(path, 'self');
  }

  useEffect(() => {
    if (pathname !== activeNav) {
      setActiveNav(`/pro${pathname}`);
    }
  }, [pathname]);

  return (
    <ul className={styles.sidebarList}>
      {options.map(({key, icon, label, path, onClick}) => (
        <li
          key={key}
          onClick={() => {
            // 埋点
            track?.(TRACK_EVENTS?.[namespace.home].accountBarButtonClick.name, {
              button_name: label,
              position: 'Bottom',
            }, namespace.home);
            // 设置当前导航
            setActiveNav(path);
            // 点击事件
            if (onClick) onClick();
          }}
          className={cx(styles.sidebarItem, activeNav === path ? styles.activeNav : '')}
        >
          <div className={cx(styles.tooltip, styles.tooltipRight)} data-tooltip={label} >
            <div className={styles.icon}>
              {activeNav === path ? icon.active : icon.normal}
            </div>
          </div>
          <span className={styles.title}>{label}</span>
        </li>
      ))}
    </ul>
  )
}

export default SideItems;